export default {
  state: {
    general: false,
    timeline: true,
  },
  mutations: {
    setLoader(state, { element, val }) {
      state[element] = val;
    },
  },
  actions: {
    setLoader({ commit }, { element, val }) {
      commit('setLoader', { element, val });
    },
  },
  getters: {
    generalLoader: (s) => s.general,
    timelineLoader: (s) => s.timeline,
  },
};
